import AuthMixin from "./AuthMixin"
import DateMixin from "./DateMixin"
import DialogMixin from "./DialogMixin"
import RevisionMixin from "./RevisionMixin"
import BreadCrumbMixin from "./BreadCrumbMixin"

export default {
  mixins: [AuthMixin, DateMixin, DialogMixin, RevisionMixin, BreadCrumbMixin]
}